import styled from 'styled-components';
import { device } from '../../../styles/breakpoints';
import { Header2 } from '../../atoms/Fonts';

export const TermsOfServiceContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const Title = styled(Header2)`
  align-self: flex-start;
`;

export const TermsText = styled.textarea`
  width: 100%;
  height: 446px;

  color: ${(props) => props.theme.colors.text.default};
  border: none;
  background: none;
  resize: none;

  font-family: 'PT Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;

  scrollbar-width: 5px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  width: 100%;

  @media ${device.mobile} {
    flex-direction: column;
  }
`;

export const CancelButtonWrapper = styled.div`
  flex: 0 0 30%;
  margin-right: 10px;

  @media ${device.mobile} {
    margin-right: 0;
    flex: 1;
  }
`;

export const AgreeButtonWrapper = styled.div`
  flex: 1;

  @media ${device.mobile} {
    margin-top: 10px;
  }
`;

export const TermsWrapper = styled.div`
  width: 100%;
  margin: 40px 0;
`;
